import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
const MisReport = ({ selectedDate }) => {
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const [misReport, setMisReport] = useState([]);
  // console.log(misReport);

  const getMisData = async () => {
    const currentQueryDate = moment(selectedDate, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );
    let BASE_URL =
      SERVER_URL + `/api/raw-mat/raw-material-details-mis-report/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        date: selectedDate,
      }),
    });
    const result = await res.json();
    if (res.ok) {
      setMisReport(result.data);
    } else {
    }
  };

  useEffect(() => {
    getMisData();
  }, [selectedDate]);

  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    pageStyle: `
      @page {
        size: auto !important;
      }
      @media print {
        table {
          width: 100%;
          border-collapse: collapse;
          border: 1px solid #ddd;
          border-spacing: 0;
          margin-bottom: 10px;
        }
        th, td {
          border: 1px solid #ddd;
          padding: 8px;
        }
      }`,
    documentTitle: "Material MIS Report",
  });
  return (
    <>
      <button onClick={generatePDF} className="btn btn-primary mb-3">
        Generate PDF
      </button>
      <div className="row" id="pdf-content">
        <div className="col-lg-12 grid-margin stretch-card">
          <div
            className="table-responsive table-bordered"
            style={{ border: "0.05px solid lightGray" }} 
          >
            <table className="table table-hover" ref={componentPDF}>
              <thead>
                <tr style={{ textAlign: "center" }}>
                  <th colSpan="5">DATE: {selectedDate} </th>
                  <th colSpan="8">MATERIALS</th>
                </tr>
                <tr>
                  {misReport &&
                    misReport.length > 0 &&
                    Object?.entries(misReport[0])?.map(([key, value]) => (
                      <th
                        key={key}
                        colSpan={
                          key === "CASTING" ? Object.keys(value).length : 1
                        }
                        rowSpan={key === "CASTING" ? "" : 2}
                        style={{
                          textAlign: key === "CASTING" ? "center" : "left",
                          verticalAlign: "middle",
                        }}
                      >
                        {key}
                      </th>
                    ))}
                </tr>
                <tr>
                  {misReport &&
                    misReport?.length > 0 &&
                    Object?.entries(misReport[0])
                      ?.filter(([key, value]) => key === "CASTING")
                      ?.map(([key, value]) => (
                        <React.Fragment key={key}>
                          {Object?.entries(value)?.map(([subKey, subValue]) => (
                            <th key={subKey}>{subKey}</th>
                          ))}
                        </React.Fragment>
                      ))}
                </tr>
              </thead>
              <tbody>
                {misReport &&
                  misReport.length > 0 &&
                  misReport.map((item, index) => (
                    <tr key={index}>
                      {Object.entries(item).map(([key, value]) => {
                        if (key === "CASTING") {
                          return (
                            <React.Fragment key={key}>
                              {Object.entries(value).map(
                                ([subKey, subValue]) => (
                                  <td key={subKey}>{subValue}</td>
                                )
                              )}
                            </React.Fragment>
                          );
                        } else {
                          return (
                            <td
                              key={key}
                              style={{ textTransform: "uppercase" , fontWeight: "bold" }}
                            >
                              {value}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default MisReport;
